import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { getWiki, WikiNamespaces } from '~/monolith-api';

const getWikiSchema = z.object({
   namespace: z.custom<WikiNamespaces>(),
   identifier: z.string().or(z.number()),
   unpatrolled: z.boolean(),
});

export default createBFFHandlers({
   post: async (request, response) => {
      const { namespace, identifier, unpatrolled } = getWikiSchema.parse(request.body);
      const monolithClient = getServerSideMonolithClient(request);
      const result = await getWiki({
         namespace,
         identifier,
         unpatrolled,
         apiClient: monolithClient,
      });
      response.status(200).json(result);
   },
});

export type GetWikiFromClientOptions = {
   unpatrolled?: boolean;
};

export const getWikiFromClient = (
   namespace: WikiNamespaces,
   identifier: string | number,
   { unpatrolled }: GetWikiFromClientOptions = {}
): ReturnType<typeof getWiki> => {
   return bff()
      .post('/wikis/getWiki', { namespace, identifier, unpatrolled })
      .then(response => response.data);
};
